import { TabItem } from '@app/data/types';
import { Endpoints } from '@data/consts';

// Read left to right, this is the order the work happens in: the brief, the conversation about
// it, the phases it was broken into, what came out of them, and only then the administrative
// tabs. Sub Tasks sat last because it was added last, which is not a reason.
//
// Each entry stays keyed by its endpoint, because that is what the permission filter reads.
const tabs: TabItem[] = [
    { icon: 'document', value: Endpoints.TASK_INFORMATION, label: 'Briefing' },
    { icon: 'send-message', value: Endpoints.TASK_MESSAGES, label: 'Messages' },
    { icon: 'layers', value: Endpoints.TASK_SUB_TICKETS, label: 'Sub Tasks' },
    { icon: 'unarchive', value: Endpoints.TASK_DELIVERABLES, label: 'Deliverables' },
    { icon: 'cog', value: Endpoints.TASK_MANAGEMENT, label: 'Management' },
    { icon: 'panel-stats', value: Endpoints.TASK_WORK_REPORTS, label: 'Work Reports' },
];

export default tabs;
